<template>
  <div class="filter">
    <div class="filter_price">
      <p>价格区间</p>
      <div class="ul">
        <div 
        @click="price_fliter(index)" 
        :class="item.isSelected ? 'current' :''"
        v-for="(item,index) in price_list" 
        :key="index">
        {{item.text}}</div>
      </div>
    </div>
    <div class="filter_price">
      <p>适用人群</p>
      <div class="ul">
        <div
        @click="people_fliter(index)" 
        :class="item.isSelected ? 'current' :''"
        v-for="(item,index) in people_list" 
        :key="index">
        {{item.text}}</div>
      </div>
    </div>
    <div class="filter_price">
      <p>成色</p>
      <div class="ul">
        <div
        @click="change_fliter(index)" 
        :class="item.isSelected ? 'current' :''"
        v-for="(item,index) in change_list" 
        :key="index">
        {{item.text}}</div>
      </div>
    </div>
    <div  class="reset">
      <span @click="fliter_reset">重置</span>
      <span @click="fliter_confim">确定</span>
    </div>
  </div>
</template>
<script>
export default {
  name : 'fliter',
  props:{
    price_list : {
      type: Array,
      default() {
        return []
      }
    },
    people_list : {
      type: Array,
      default() {
        return []
      }
    },
    change_list : {
      type: Array,
      default() {
        return []
      }
    }
  },
  mounted(){
    console.log(this.price_list)
  },
  methods:{
    price_fliter(i){
      this.$emit("selectprice",i)
    },
    people_fliter(i){
      this.$emit("selectpeople",i)
    },
    change_fliter(i){
      this.$emit("selectchange",i)
    },
    fliter_reset(){
      this.$emit("fliter_reset")
    },
    fliter_confim(){
      this.$emit('fliter_confim')
    }
  }
}
</script>
<style lang="less" scoped>
.current{
  color: black !important;
  background: #FFD133FF !important;
}
.current:before{
  position: absolute;
  content: '';
  width: 19px;
  height: 13.8px;
  left: 5%;
  top: 35%;
  background: url(../../assets/picture/success.png);
  background-size: 100%;
}
.filter{
  position: relative;
  background: white;
  margin-top: -1px;
  .filter_price{
    width: 100%;
    height: 4rem;
    p{
      font-size : 28px;
      padding-left: 30px;
      margin-top: 2px;
      line-height: 50px;
      padding-top: .5rem;
    }
     .ul{
      width: 100%;
      div{
        width: 218px;
        height: 56px;
        background: rgb(247,247,247);
        text-align: center;
        line-height: 56px;
        float: left;
        font-size: 20px;
        margin-left: 25px;
        margin-top: 25px;
        position: relative;
        img{
          width: 18px;
          height: 12px;
          position: absolute;
          left: 5%;
          top: 35%;
        }
      }
      // div:first-child{
      //   display: none;
      // }
    }
  }
  .filter_price:nth-child(2){
    height: 2.8rem;
  }
  .filter_price:nth-child(3){
    height: 4.5rem;
  }
  .reset{
    width: 100%;
    height: 1.2rem;
    background: white;
    left: 0;
    color: black;
    position: inherit;
    span{
      display: block;
      width: 50%;
      height: 100%;
      font-size: 28px;
      float: left;
      line-height: 90px;
      text-align: center;
    }
    span:nth-child(2){
      background: #FFD133FF;
    }
  }
}
</style>